'use client';

import { useEffect } from 'react';
import { useQuotaErrorListener, QuotaErrorPayload } from '@/lib/global-events';
import { useQuotaNotification } from '@/contexts/QuotaNotificationContext';

/**
 * A non-rendering component that listens for global quota error events
 * and triggers the notification banner via its context.
 */
const QuotaNotificationListener: React.FC = () => {
  const { showQuotaNotification } = useQuotaNotification();

  useQuotaErrorListener(({ message }: QuotaErrorPayload) => {
    showQuotaNotification(message);
  });

  return null; // This component does not render anything
};

export default QuotaNotificationListener;
